import { render, staticRenderFns } from "./ResultsHeader.vue?vue&type=template&id=43db837c&"
import script from "./ResultsHeader.vue?vue&type=script&lang=ts&"
export * from "./ResultsHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports